import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type RampBillLinkFieldsFragment = { __typename?: 'RampBillLinkData', rampBillId: string, purchaseOrderId?: string | null };

export type LinkRampBillToPurchaseOrderMutationVariables = Types.Exact<{
  input: Types.LinkRampBillToPurchaseOrderInput;
}>;


export type LinkRampBillToPurchaseOrderMutation = { __typename?: 'Mutation', linkRampBillToPurchaseOrder: { __typename?: 'RampBillLinkPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, rampBillLink?: { __typename?: 'RampBillLinkData', rampBillId: string, purchaseOrderId?: string | null } | null } };

export type UnlinkRampBillFromPurchaseOrderMutationVariables = Types.Exact<{
  input: Types.UnlinkRampBillFromPurchaseOrderInput;
}>;


export type UnlinkRampBillFromPurchaseOrderMutation = { __typename?: 'Mutation', unlinkRampBillFromPurchaseOrder: { __typename?: 'RampBillLinkPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, rampBillLink?: { __typename?: 'RampBillLinkData', rampBillId: string, purchaseOrderId?: string | null } | null } };

export const RampBillLinkFieldsFragmentDoc = new TypedDocumentString(`
    fragment RampBillLinkFields on RampBillLinkData {
  rampBillId
  purchaseOrderId
}
    `, {"fragmentName":"RampBillLinkFields"});
export const LinkRampBillToPurchaseOrderDocument = new TypedDocumentString(`
    mutation LinkRampBillToPurchaseOrder($input: LinkRampBillToPurchaseOrderInput!) {
  linkRampBillToPurchaseOrder(input: $input) {
    errors {
      code
      message
    }
    rampBillLink {
      ...RampBillLinkFields
    }
  }
}
    fragment RampBillLinkFields on RampBillLinkData {
  rampBillId
  purchaseOrderId
}`);
export const UnlinkRampBillFromPurchaseOrderDocument = new TypedDocumentString(`
    mutation UnlinkRampBillFromPurchaseOrder($input: UnlinkRampBillFromPurchaseOrderInput!) {
  unlinkRampBillFromPurchaseOrder(input: $input) {
    errors {
      code
      message
    }
    rampBillLink {
      ...RampBillLinkFields
    }
  }
}
    fragment RampBillLinkFields on RampBillLinkData {
  rampBillId
  purchaseOrderId
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    LinkRampBillToPurchaseOrder: build.mutation<LinkRampBillToPurchaseOrderMutation, LinkRampBillToPurchaseOrderMutationVariables>({
      query: (variables) => ({ document: LinkRampBillToPurchaseOrderDocument, variables })
    }),
    UnlinkRampBillFromPurchaseOrder: build.mutation<UnlinkRampBillFromPurchaseOrderMutation, UnlinkRampBillFromPurchaseOrderMutationVariables>({
      query: (variables) => ({ document: UnlinkRampBillFromPurchaseOrderDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useLinkRampBillToPurchaseOrderMutation, useUnlinkRampBillFromPurchaseOrderMutation } = injectedRtkApi;
